import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { motion } from 'framer-motion';
import { styled } from 'styled-components';
import { ProcessingIndicator } from './ProcessingIndicator.js';
import { useExpandedFdocContext } from '../../ExpandedFdoc/ExpandedFdocProvider.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Flex } from '@fabric-app/ui/components/Flex';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import { preventForwardPropsConfig } from '@fabric-app/ui/utils/preventForwardProps';
import { useExpandedResource, useShowPreviousExpandedResource } from '../../../../resources/stores/useExpandedResourceStore.js';
import { Button } from '@fabric-app/ui/components/Button';
import { IconNavigational24Search, IconArrow } from '@fabric-app/icons/svg';
import { useSubDocumentSearch } from '../../../../search/context/SubDocumentSearchContext.js';
import SubDocumentSearch from '../../../../search/components/subDocument/SubDocumentSearch.js';
import { useResourceDataContext } from '../../context/resourceDataContext.js';

const ButtonPreviousResource = () => {
  const showPreviousResource = useShowPreviousExpandedResource();
  if (showPreviousResource) {
    return /* @__PURE__ */ jsx(Button, {
      shape: "square",
      variant: "transparent",
      style: {
        padding: 0,
        width: 24,
        height: 24,
        color: cssVar["color-text-primary"]
      },
      onClick: showPreviousResource,
      children: /* @__PURE__ */ jsx(IconArrow, {
        style: {
          fontSize: "1.35rem"
        }
      })
    });
  }
  return null;
};
const HeaderWrapperBase = styled(motion.div).withConfig({
  displayName: "ModalResourceHeader__HeaderWrapperBase",
  componentId: "sc-b455cfbc-0"
})([
  `display:flex;align-items:center;justify-content:space-between;height:calc(var(--safe-margin-offset-top) + 4rem);padding:0 1rem;padding-top:calc(var(--safe-margin-offset-top));border-bottom:1px solid `,
  `;gap:1rem;position:relative;z-index:40;background:`,
  `;flex-shrink:0;`
], cssVar["color-border-primary"], cssVar["color-bg-primary"]);
const Left = styled(Flex).attrs(({ children, ...rest }) => {
  return {
    alignItems: "center",
    overflow: "hidden",
    ...rest,
    children: /* @__PURE__ */ jsxs(Fragment, {
      children: [
        /* @__PURE__ */ jsx(ButtonPreviousResource, {}),
        /* @__PURE__ */ jsx(ProcessingIndicator, {}),
        children
      ]
    })
  };
}).withConfig(preventForwardPropsConfig([
  "resource"
])).withConfig({
  displayName: "ModalResourceHeader__Left",
  componentId: "sc-b455cfbc-1"
})([
  `gap:0.25rem;flex-grow:1;width:1px;height:100%;& > *{padding-left:0;margin-left:0;}`
]);
const Right = styled(Flex).attrs(({ children, ...rest }) => {
  const { isAnon } = useExpandedFdocContext();
  const expandedResourceId = useExpandedResource();
  const { isAvailable: isSubDocumentSearchAvailable, setOpen: setSubDocumentSearchOpen, isOpen: isSubDocumentSearchOpen } = useSubDocumentSearch();
  const { willRegisterSubdocumentSearch } = useResourceDataContext();
  return {
    alignItems: "center",
    overflow: "hidden",
    ...rest,
    children: /* @__PURE__ */ jsxs(Fragment, {
      children: [
        (willRegisterSubdocumentSearch || isSubDocumentSearchAvailable) && /* @__PURE__ */ jsx(Modal.IconButton, {
          onClick: () => setSubDocumentSearchOpen(!isSubDocumentSearchOpen),
          children: /* @__PURE__ */ jsx(IconNavigational24Search, {})
        }),
        /* @__PURE__ */ jsx(SubDocumentSearch, {}),
        !isAnon && children,
        expandedResourceId && /* @__PURE__ */ jsx(Modal.Close, {
          variant: "bg-secondary",
          size: "default",
          "data-testid": "close-preview-button"
        })
      ]
    })
  };
}).withConfig({
  displayName: "ModalResourceHeader__Right",
  componentId: "sc-b455cfbc-2"
})([
  `gap:0.5rem;& > *{margin-left:0;}`
]);
const HeaderWrapper = Object.assign(HeaderWrapperBase, {
  Left,
  Right
});

export { HeaderWrapper };
//# sourceMappingURL=ModalResourceHeader.js.map
